module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on both jaws13.a9b12b30.png";